import { Avatar, ButtonBase, Text } from '@belong/ui';
import { EmployeeAssignmentDetailModel } from 'api/models';

type MaintenanceHomecareSpecialistProps = {
  homecareSpecialist: EmployeeAssignmentDetailModel;
  onScheduleACallPress: () => void;
};

export const MaintenanceHomecareSpecialist = ({
  homecareSpecialist,
  onScheduleACallPress,
}: MaintenanceHomecareSpecialistProps) => {
  return (
    <div className="mb-xl flex w-full flex-col border border-x-0 border-dashed border-gray py-lg md:flex-row md:items-center md:justify-between">
      <div className="flex items-center">
        {/* `user` and its image are optional on the assignment model, but this
            card is only rendered for a specialist that has been assigned. */}
        <Avatar size={40} src={homecareSpecialist.user!.profileImageUrl!} />
        <div className="ml-sm">
          <Text fontWeight="semibold">{homecareSpecialist.user!.name}</Text>
          <Text variant="p1">Your Homecare Specialist</Text>
        </div>
      </div>

      <ButtonBase
        className="mt-lg self-end md:mt-0 md:self-center"
        onClick={onScheduleACallPress}
      >
        <Text
          className="text-green transition-colors duration-hover hover:text-dark-green"
          fontWeight="semibold"
        >
          SCHEDULE A CALL WITH ME
        </Text>
      </ButtonBase>
    </div>
  );
};
